/**
 * B Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface BBookDecreasePositionLog {
  id?: number;
  timestamp?: string;
  comment?: string;
  closedPnl?: number;
  pairId?: number;
}
